<template>
  <div
    v-if="pagination"
    class="pagination"
    :class="{
      [`pagination--light`]: lightVersion,
      'pagination--center': center,
    }"
  >
    <paginate
      :value="currentPage"
      :page-count="pageCount"
      :page-range="3"
      :margin-pages="1"
      :click-handler="clickCallback"
      prev-class="pagination__button pagination__button--prev"
      next-class="pagination__button pagination__button--next"
      prev-text=""
      next-text=""
      :use-href="useHref"
      :default-route="routeName"
      :default-pagination-route="routePaginationName"
      container-class="pagination__list"
      page-class="pagination__item"
    />
  </div>
</template>

<script>
import Paginate from '~/components/Paginate';

export default {
  name: 'Pagination',
  components: {
    Paginate,
  },
  props: {
    pagination: {
      type: Object,
      default: () => {},
    },
    lightVersion: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    useHref: {
      type: Boolean,
      default: false,
    },
    routeName: {
      type: String,
      default: '',
    },
    routePaginationName: {
      type: String,
      default: '',
    },
    scrollId: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentPage() {
      let offset = this.pagination.offset / this.pagination.limit + 1;
      if (offset === 0) {
        offset = 1;
      }
      return offset;
    },
    pageCount() {
      let pageCount = Math.ceil(this.pagination.countTotal / this.pagination.limit);
      if (pageCount === 0) {
        pageCount = 1;
      }
      return pageCount;
    },
  },
  methods: {
    clickCallback(pageNum) {
      if (this.scrollId) {
        this.$helper.scrollToId(this.scrollId);
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      this.$emit('change', pageNum);
    },
  },
};
</script>

<style lang="scss">
.pagination {
  $root: &;
  display: flex;
  align-items: center;
  /* margin-left: -0.7rem;
  margin-right: -0.7rem; */

  &__list {
    display: flex;
    align-items: center;
  }

  &__item {
    font-size: 1.2rem;
    line-height: 1.5rem;
    letter-spacing: 0.05em;
    font-weight: 700;
    color: $cAddDark02;
    transition: background-color $tr, color $tr;

    a {
      display: block;
      padding: 5px 9px;
    }

    &.active {
      background-color: $cBg;
      border-radius: 4px;
      color: $cMainDark;
    }

    &:not(.active) {
      &:hover {
        color: $cSec;
      }
    }
  }

  &__button {
    font-size: 0.8rem;
    color: $cAddDark02;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }

    a {
      padding: 0.7rem;
    }

    &--next {
      a {
        &:before {
          @include icomoon('single-chevron-right');
        }
      }
    }

    &--prev {
      a {
        &:before {
          @include icomoon('single-chevron-left');
        }
      }
    }

    &.disabled {
      display: none;
    }
  }

  &--light {
    #{$root}__item.active {
      background-color: $cWhite;
    }
  }

  &--center {
    justify-content: center;
  }
}
</style>
